import React, { Component } from "react"
import { Link } from "gatsby"
import { trackCustomEvent, OutboundLink } from "gatsby-plugin-google-analytics"

import * as Styled from "../Icons/styled"
import { Container, Navigation } from "../NavBar/styled"

import logo from "../../images/logo.png"

class Navbar extends Component {
  state = {
    isOpen: false,
  }

  handleClick = () => {
    document.querySelector(".navbar-container").scrollIntoView({
      behavior: "smooth",
    })

    this.setState({
      isOpen: !this.state.isOpen,
    })
  }
  render() {
    return (
      <>
        <Container>
          <div className="navbar-container" onClick={this.handleClick}>
            <Navigation>
              <nav>
                <div className="logo-btn">
                  <div className="logo">
                    <Link to="/">
                      <img
                        className="image-logo"
                        src={logo}
                        alt="Dev Dojo Sistemas"
                      />
                      <h1>Wallace Sanvier</h1>
                    </Link>
                  </div>

                  <div className="btn" onClick={this.handleClick}>
                    <Styled.HomeWrapper />
                  </div>
                </div>

                <ul className={this.state.isOpen ? "showNav" : "undefined"}>
                  <li>
                    <Link to="/">
                      <Styled.HomeWrapper />
                      Início
                    </Link>
                  </li>
                  <li>
                    <Link to="/about">
                      <Styled.LibraryBooksWrapper />
                      Sobre Mim
                    </Link>
                  </li>

                  <li>
                    <OutboundLink
                      onClick={e => {
                        trackCustomEvent({
                          category: "Custom Button",
                          action: "Click",
                          label: "Botao do Whatsapp",
                        })
                      }}
                      href="https://wa.me/5562991375293?text=Saudações!%20Solicito%20o%20seu%20atendimento."
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Whatsapp!{" "}
                      <Styled.WhatsappWrapper style={{ color: "black" }} />
                    </OutboundLink>
                  </li>
                </ul>
              </nav>
            </Navigation>
          </div>
        </Container>
      </>
    )
  }
}

export default Navbar
